'use server'

import { apiRequest, ApiResponse } from '../request'

export interface ChatFolder {
    id: number
    name: string
    color?: string | null
    _count?: { items: number }
    createdAt: string
    updatedAt: string
}

export async function getChatFolders(): Promise<ApiResponse<ChatFolder[]>> {
    return apiRequest<ChatFolder[]>('chat-folders', {}, 'get')
}

export async function createChatFolder(data: {
    name: string
    color?: string
}): Promise<ApiResponse<ChatFolder>> {
    return apiRequest<ChatFolder>('chat-folders', { data }, 'post')
}

export async function updateChatFolder(
    id: number,
    data: { name?: string; color?: string }
): Promise<ApiResponse<ChatFolder>> {
    return apiRequest<ChatFolder>(`chat-folders/${id}`, { data }, 'patch')
}

export async function deleteChatFolder(
    id: number
): Promise<ApiResponse<{ success: boolean }>> {
    return apiRequest<{ success: boolean }>(`chat-folders/${id}`, {}, 'delete')
}

export async function moveChatToFolder(data: {
    chatId: number
    folderId: number
}): Promise<ApiResponse<{ id: number }>> {
    return apiRequest<{ id: number }>('chat-folders/move', { data }, 'post')
}

export async function removeChatFromFolder(
    chatId: number
): Promise<ApiResponse<{ success: boolean }>> {
    return apiRequest<{ success: boolean }>(
        `chat-folders/items/${chatId}`,
        {},
        'delete'
    )
}

export async function getChatFolderForChat(
    chatId: number
): Promise<ApiResponse<{ folderId: number | null }>> {
    return apiRequest<{ folderId: number | null }>(
        `chat-folders/for-chat/${chatId}`,
        {},
        'get'
    )
}
